import React from 'react';
export function UrgencyBar() {
  return <div className="bg-brand-red text-white text-center py-3 px-5 font-montserrat font-bold tracking-[1.5px] uppercase text-[9px]" data-id="element-173">
      <span className="animate-blink" data-id="element-174">🔥</span>
      &nbsp; OFERTA DE LANZAMIENTO · PRECIO ESPECIAL POR TIEMPO LIMITADO &nbsp;
      <span className="animate-blink" data-id="element-175">🔥</span>
    </div>;
}